import {
  Badge,
  Container,
  HStack,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import { FiFile } from "react-icons/fi"

import { PermissionGate } from "@/features/auth"
import { FileManager } from "@/features/file-manager"

export const Route = createFileRoute("/_layout/files")({
  component: FilesPage,
})

function FilesPage() {
  return (
    <Container maxW="container.xl" py={8}>
      <Stack gap={6}>
        {/* Page Header */}
        <Stack gap={2}>
          <HStack>
            <FiFile size={24} />
            <Heading size="lg">Files</Heading>
          </HStack>
          <Text color="gray.600">
            Upload, manage, and organize your files. Share files publicly or
            keep them private.
          </Text>
          <HStack>
            <Badge colorScheme="blue" variant="outline">
              Drag & Drop Upload
            </Badge>
            <Badge colorScheme="green" variant="outline">
              File Preview
            </Badge>
            <Badge colorScheme="purple" variant="outline">
              Public/Private Toggle
            </Badge>
          </HStack>
        </Stack>

        {/* File Manager */}
        <PermissionGate
          scopes={["files:read"]}
          fallback={
            <Text color="red.500" textAlign="center" py={8}>
              You don't have permission to access file management.
            </Text>
          }
        >
          <FileManager
            title="My Files"
            uploadType="attachment"
            showUpload={true}
            showList={true}
          />
        </PermissionGate>
      </Stack>
    </Container>
  )
}
